import React from 'react'
import Modal from 'react-bootstrap/cjs/Modal'
import styled from 'styled-components'
import { _, colors } from 'utils'
import Button from './Button'

const S = {
    ModalHeader: styled(Modal.Header)`
        position: relative;
        padding: 30px;
        font-weight: 500;
        font-size: 30px;
        line-height: 35px;
        color: ${colors.dark};
        border-bottom: none;
        & button {
            position: absolute;
            top: 18px;
            right: 30px;
            color: ${colors.icon};
            font-size: 34px;
            font-weight: 400;
            opacity: 1 !important;
        }
    `,
    ModalBody: styled(Modal.Body)`
        padding: 0 30px 40px 30px;
        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        color: ${colors.grayDescription};
    `,
    ModalFooter: styled(Modal.Footer)`
        padding: 0 30px 20px 30px;
        display: flex;
        justify-content: flex-end;
        border-top: none;
        & > button:first-child {
            margin-right: 10px;
        }
    `
}

export interface ConfirmModalProps {
    close: () => void
    title?: string
    confirmDescription?: string|React.ReactNode
    confirmText?: string
    onConfirm?: (e?: any) => void
    disabledConfirm?: boolean
    onBeforeConfirm?: () => Promise<boolean>
    variantConfirm?: 'primary' | 'secondary' | 'success' | 'danger'
    cancelText?: string
    onCancel?: (e?: any) => void
    variantCancel?: 'primary' | 'secondary' | 'success' | 'danger'
}

const ConfirmModal = ({
    close,
    title,
    confirmDescription,
    confirmText = _('button.accept'),
    disabledConfirm,
    onConfirm = () => null,
    onBeforeConfirm = async () => true,
    variantConfirm = 'danger',
    cancelText = _('button.cancel'),
    onCancel = () => null,
    variantCancel = 'secondary',
}: ConfirmModalProps) => {
    const [show, setShow] = React.useState(true)
    const handleClose = (callBack) => {
        setShow(false)
        setTimeout(() => {
            close()
            callBack && callBack()
            setShow(true)
        }, 250)
    }

    const handleConfirm = async (callBack) => {
        if (!onBeforeConfirm || await onBeforeConfirm()) {
            handleClose(callBack)
        }
    }

    return (
        <Modal centered show={show} onHide={() => handleClose(onCancel)}>
            <S.ModalHeader closeButton>
                {title}
            </S.ModalHeader>
            <S.ModalBody>
                {confirmDescription}
            </S.ModalBody>
            <S.ModalFooter>
                <Button onClick={() => handleClose(onCancel)} variant={variantCancel}>
                    {cancelText}
                </Button>
                <Button
                    onClick={() => handleConfirm(onConfirm)}
                    variant={variantConfirm}
                    disabled={disabledConfirm}
                >
                    {confirmText}
                </Button>
            </S.ModalFooter>
        </Modal>
    )
}

export default ConfirmModal
